import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './Security.css';

function formatDeadline(ms) {
  try {
    const d = new Date(ms);
    const opts = { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' };
    // Include the year when the deadline is not in the current year so a
    // far-out grace window can't read like a date in the past.
    if (d.getFullYear() !== new Date().getFullYear()) opts.year = 'numeric';
    return d.toLocaleString(undefined, opts);
  } catch {
    return '';
  }
}

/** Shown while a user is inside the MFA grace window without a proven second factor. */
export default function MfaGraceBanner({ onSetUp }) {
  const { showMfaGraceBanner, mfaExemptUntilMs, isMicrosoftUser, mfaEnrolled } = useAuth();
  if (!showMfaGraceBanner) return null;

  const deadline = mfaExemptUntilMs ? formatDeadline(mfaExemptUntilMs) : null;

  if (isMicrosoftUser) {
    return (
      <div className="sec-grace-banner" role="status">
        <span>
          Starting {deadline || 'soon'}, sign in with <strong>Sign in with Microsoft</strong> (Duo) to use Trilogy One Care.
        </span>
      </div>
    );
  }

  return (
    <div className="sec-grace-banner" role="status">
      <span>
        {mfaEnrolled
          ? <>Two-step verification is set up — it will be required at every sign-in starting {deadline || 'soon'}.</>
          : <>Two-step verification will be required starting <strong>{deadline || 'soon'}</strong>. Set it up now so you are not interrupted.</>}
      </span>
      {!mfaEnrolled && (
        <button type="button" className="sec-btn sec-btn--primary" onClick={onSetUp}>Set up now</button>
      )}
    </div>
  );
}
